/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiBreedListParams } from './model/apiBreedListParams';
import type { PaginatedBreedList } from './model/paginatedBreedList';

/**
 * Sets reasonable pagination defaults for all the API list views.
 */
export const apiBreedList = (params?: ApiBreedListParams, signal?: AbortSignal) => {
  return HTTP<PaginatedBreedList>({ url: `/api/v7/breeds/`, method: 'GET', params, signal });
};

export const getApiBreedListQueryKey = (params?: ApiBreedListParams) => {
  return [`/api/v7/breeds/`, ...(params ? [params] : [])] as const;
};

export const getApiBreedListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiBreedList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiBreedListParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof apiBreedList>>, TError, TData> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiBreedListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiBreedList>>> = ({ signal }) =>
    apiBreedList(params, signal);

  return {
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof apiBreedList>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ApiBreedListQueryResult = NonNullable<Awaited<ReturnType<typeof apiBreedList>>>;
export type ApiBreedListQueryError = ErrorType<unknown>;

export function useApiBreedList<
  TData = Awaited<ReturnType<typeof apiBreedList>>,
  TError = ErrorType<unknown>
>(
  params?: ApiBreedListParams,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof apiBreedList>>, TError, TData> }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiBreedListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
